import React from 'react';
import { Row } from '@fasstech/middle-design-system';

const InformationTable = ({ items }) => {
  // Reducing the items array to an array of pairs
  const pairedItems = items.reduce((acc, _, i) => {
    if (i % 2 === 0) {
      acc.push(items.slice(i, i + 2));
    };
    return acc;
  }, []);
  return (
    <div className="grid grid-cols-2 gap-4 [&>div>div:last-child]:max-w-[60%]!">
      {pairedItems.map((itemPair, i) =>
        <>
          <Row item={itemPair[0]} index={i}/>
          {itemPair[1] &&
            <Row item={itemPair[1]} index={i}/>
          }
        </>
      )}
    </div>
  );
};

export default InformationTable;
